<div
  class="fixed top-4 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded shadow-lg text-white"
  [ngClass]="{
    'bg-green-600': type === 'success',
    'bg-red-600': type === 'error'
  }"
>
  {{ message }}
</div>
